export default "__VITE_ASSET__BM3rgeOq__"